var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "callIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.556,
    viewBox: "0 0 14 15.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15127",
    "data-name": "\\uADF8\\uB8F9 15127",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27123",
    "data-name": "\\uD328\\uC2A4 27123",
    d: "M344,562v-2c0-4.418-2.686-8-6-8s-6,3.582-6,8v2",
    transform: "translate(-332 -552)",
    fill: "none",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27124",
    "data-name": "\\uD328\\uC2A4 27124",
    d: "M386.926,562.43a2.374,2.374,0,0,1-.26.014h-1.556a.778.778,0,0,1-.778-.778V557a.778.778,0,0,1,.778-.778h2.278a5.445,5.445,0,0,0-10.778,0h2.278a.778.778,0,0,1,.778.778v4.667a.778.778,0,0,1-.778.778h-1.556A2.333,2.333,0,0,1,375,560.111V557a7,7,0,0,1,14,0v3.127a6.984,6.984,0,0,1-2.371,5.234.779.779,0,0,1-.515.194H382A.778.778,0,1,1,382,564h3.809A5.455,5.455,0,0,0,386.926,562.43Z",
    transform: "translate(-375 -550)",
    fill: "#666",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.93b862981fd8a2ca095070f031396583.svg";
export { ForwardRef as ReactComponent };